import { useAuth } from "@/context/AuthContext";
import AuthWall from "@/components/AuthWall";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-zinc-500">
        Loading…
      </div>
    );
  }
  if (user === false) return <AuthWall />;
  return children;
}
